import { Tabs, Tab, Grid } from '@mui/material';
import { Currency } from '@/components/general/Currency/Currency';
import { usePhrase } from '@/hooks';
import { IAccount } from '@/types/types';

interface AccountSelectorProps {
    accounts: IAccount[];
    tabVal: number;
    setTabVal: (val: number) => void;
}

export const AccountSelector = ({ accounts, tabVal, setTabVal }: AccountSelectorProps) => {
    const { t } = usePhrase();

    if (accounts.length <= 1) return <></>;

    return (
        <Tabs
            sx={{ mb: 2 }}
            variant={'scrollable'}
            onChange={(_evt, val: number) => setTabVal(val)}
            value={tabVal}
        >
            {accounts.map((account) => (
                <Tab
                    key={account.accountId}
                    sx={{ minWidth: ['auto', 'auto', '240px'], px: 3 }}
                    label={
                        <Grid>
                            {t(account.currencyNamePhraseId)}
                            <span> &#8212; </span>
                            <Currency
                                code={account.currencyCode}
                                symbol={account.currencySymbol}
                                position={account.currencySymbolPosition}
                                amount={account.balance}
                            />
                        </Grid>
                    }
                    value={account.accountId}
                />
            ))}
        </Tabs>
    );
};
